import { NodeSpec } from 'prosemirror-model';
import {
  addColumnAfter,
  addRowAfter,
  deleteColumn,
  deleteRow,
  deleteTable,
  goToNextCell,
} from 'prosemirror-tables';

import { BaseExtension } from '@lyearn/lygo-core';

import { NODE_NAME } from './consts';
import plugins from './plugins';
import { getTableNode } from './utils';

export default class Table extends BaseExtension {
  get schema(): NodeSpec {
    return getTableNode('table');
  }

  get name(): string {
    return NODE_NAME;
  }

  get keys() {
    return {
      Tab: goToNextCell(1),
      'Shift-Tab': goToNextCell(-1),
      'Shift-Backspace': deleteTable,
      'Mod-Shift-Enter': addRowAfter,
      'Mod-Shift-Backspace': deleteRow,
      'Mod-Shift-ArrowLeft': deleteColumn,
      'Mod-Shift-ArrowRight': addColumnAfter,
    };
  }

  plugins = plugins;
}
